import { useQuery } from '@tanstack/react-query';
import type { SyncLogIdentifier } from '../types';
import { useSyncApi } from './use-sync-api';

export const useSyncStatus = (identifier: SyncLogIdentifier) => {
  const { syncApi } = useSyncApi();

  return useQuery({
    queryKey: ['sync-status', identifier],
    queryFn: () => syncApi.logs().for(identifier).status(),
    enabled: !!identifier.integration && !!identifier.dataType,
  });
};
